/**
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';
import AppService from '@/services/app';
import Store from '@/store/index';

import { EmailAddress } from '@/models/EmailAddress.model';

export default {

  resetTypes() {
    // reset store to empty
    Store.dispatch('emailAddresses/setEmailTypes', {
      emailTypes: [],
    });
  },

  async listTypes(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['emailAddresses/emailTypes'].length < 1) {
      try {
        const response = await Api(true).get('/customer/email/list_types');

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetTypes();
            return response.data.message;
          } else {
            Store.dispatch('emailAddresses/setEmailTypes', {
              emailTypes: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetTypes();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('emailAddress.ts - listTypes - 48 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  resetStore() {
    // reset store to empty
    Store.dispatch('emailAddresses/setEmailAddresses', {
      emailAddresses: [],
    });
  },

  async listAll(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['emailAddresses/emailAddresses'].length < 1) {
      try {
        const response = await Api(true).get('/customer/email/list_all');

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetStore();
            return response.data.message;
          } else {
            Store.dispatch('emailAddresses/setEmailAddresses', {
              emailAddresses: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetStore();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('emailAddress.ts - listAll - 91 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  update(params: { customerId: number, emailAddresses: EmailAddress[] }) {
    return Api(true).post('/customer/email/update', params);
  },

};
